import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';

export class GeocodingPermissionHelper {
    static isGeocodingEnabledOnSite() {
        return FeatureFlags.addressGeocodingEnabled && FeatureFlags.addressGeocodingOnSiteEnabled;
    }

    static isGeocodingEnabledForServer() {
        // TODO: @W-16268374 addressGeocodingOnSiteEnabled check is a temporary solution
        // Users should only be able to see full geocoding UI and run estimate and geocoding jobs if their 
        // company has purchased geocoding tokens. For Online, this will be handled by LaunchDarkly. 
        // Figure out how to handle this for Server
        return FeatureFlags.addressGeocodingEnabled && FeatureFlags.addressGeocodingOnSiteEnabled;
    }
}